(() => {
  if (window.starboostSmallDecimalsLoaded) return;
  window.starboostSmallDecimalsLoaded = true;

  // Solo elementos de precio. No buscar números en toda la página.
  const priceSelectors = [
    ".price-item",
    ".quantity-break__price",
    ".quantity-break__compare-price",
    ".cart-item__price",
    ".cart-item__old-price",
    ".cart-item__final-price",
    ".cart-item__original-price",
    ".cart-item__discounted-prices .product-option",
    ".cart-item__totals .product-option",
    ".totals__subtotal-value",
    ".totals__total-value",
    ".cart-item__price-wrapper .price--end",
    ".cart-drawer-item__saving",
    ".cart-drawer__totals__row__money",
    ".upsell__price .regular-price",
    ".upsell__price .compare-price"
  ].join(",");

  const excludedSelectors = [
    ".sb-price-currency",
    ".sb-price-decimals",
    ".price__fraction",
    ".price__decimal-point",
    ".visually-hidden",
    "[aria-hidden='true']",
    "script",
    "style",
    "input",
    "textarea",
    "select"
  ].join(",");

  function formatTextNode(node) {
    const text = node.nodeValue;

    // Formato actual: 49.95 o 1,049.95.
    const pattern = /(\d[\d,]*)\.(\d{2})(?!\d)/g;
    const matches = Array.from(text.matchAll(pattern));
    if (!matches.length) return;

    const fragment = document.createDocumentFragment();
    let position = 0;

    matches.forEach((match) => {
      fragment.appendChild(
        document.createTextNode(
          text.slice(position, match.index) + match[1]
        )
      );

      // Se oculta visualmente el punto, pero se conserva en el texto.
      const point = document.createElement("span");
      point.className = "sb-price-decimal-point";
      point.textContent = ".";
      fragment.appendChild(point);

      const decimals = document.createElement("sup");
      decimals.className = "sb-price-decimals";
      decimals.textContent = match[2];
      fragment.appendChild(decimals);

      position = match.index + match[0].length;
    });

    fragment.appendChild(
      document.createTextNode(text.slice(position))
    );

    node.replaceWith(fragment);
  }

  function formatCurrencySymbol(node) {
  const text = node.nodeValue;
  if (!text.includes("S$")) return;

  const fragment = document.createDocumentFragment();
  const parts = text.split("S$");

  parts.forEach((part, index) => {
    if (index > 0) {
      const symbol = document.createElement("span");
      symbol.className = "sb-price-currency";
      symbol.textContent = "S$";
      fragment.appendChild(symbol);
    }

    fragment.appendChild(document.createTextNode(part));
  });

  node.replaceWith(fragment);
}


  function formatPrices() {
    const textNodes = new Set();

    document.querySelectorAll(priceSelectors).forEach((element) => {
      if (element.closest(excludedSelectors)) return;

      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            const parent = node.parentElement;

            if (!parent || parent.closest(excludedSelectors)) {
              return NodeFilter.FILTER_REJECT;
            }

            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      while (walker.nextNode()) {
        textNodes.add(walker.currentNode);
      }
    });

    textNodes.forEach(formatTextNode);

// Recoger de nuevo los textos tras separar los decimales.
const symbolNodes = new Set();

document.querySelectorAll(priceSelectors).forEach((element) => {
  if (element.closest(excludedSelectors)) return;

  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        const parent = node.parentElement;

        return !parent || parent.closest(excludedSelectors)
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      }
    }
  );

  while (walker.nextNode()) {
    symbolNodes.add(walker.currentNode);
  }
});

symbolNodes.forEach(formatCurrencySymbol);

  }

  function start() {
    let scheduled = false;

    const observerOptions = {
      childList: true,
      characterData: true,
      subtree: true
    };

    const observer = new MutationObserver((mutations) => {
      const priceChanged = mutations.some((mutation) => {
        const target = mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;

        if (target && target.closest(priceSelectors)) return true;

        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;

          return node.matches(priceSelectors) ||
            Boolean(node.querySelector(priceSelectors));
        });
      });

      if (!priceChanged || scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;

        // No observar los cambios que hace este mismo script.
        observer.disconnect();
        formatPrices();
        observer.observe(document.body, observerOptions);
      });
    });

    formatPrices();
    observer.observe(document.body, observerOptions);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
